'use client'

import dynamic from 'next/dynamic'
import { ReactNode } from 'react'
import { MatomoProvider } from '@domain/matomo/MatomoProvider'

const GlobalRouteTracker = dynamic(
  () =>
    import('@domain/matomo/GlobalRouteTracker').then((m) => ({
      default: m.GlobalRouteTracker,
    })),
  { ssr: false },
)

/**
 * Defers Matomo route tracking out of the root client chunk so marketing
 * routes pay for analytics only after hydration (reduces TBT on / and /app).
 *
 * MatomoProvider wraps the app so event hooks keep working. Only the route
 * tracker is dynamically imported; never wrap `{children}` in `ssr: false`
 * or Next.js bails the entire page out of static HTML rendering.
 */
export function DeferredAnalytics({ children }: { children: ReactNode }) {
  return (
    <MatomoProvider>
      <GlobalRouteTracker />
      {children}
    </MatomoProvider>
  )
}
